import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Button, Icon, message, Tree } from 'antd';
import API_URL from '../../common/url';
import './style/executeMgr.less';

const TreeNode = Tree.TreeNode;

class CutoverModal extends Component {
    state = {
        list: [],
        targetId: '',
        optionList: [],
        targetName: '',
        cutOverName: '',
        visible: false,
        moduleDefineId: '',
        confirmLoading: false,
    }

    show = (record) => {
        const { moduleDefineId, uncutModuleDefine } = record;
        const optionList = uncutModuleDefine.split('//');

        this.setState({
            list: [],
            optionList,
            visible: true,
            moduleDefineId,
            showCascader: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            targetId: '',
            visible: false,
            targetName: '',
            cutOverName: '',
            showCascader: false,
        });
    }

    loadData = () => {
        const options = {
            url: `${API_URL.executeMgr.listFilterFailOption}`,
            data: {},
            dataType: 'json',
            doneResult: (res => {
                this.setState({ dataList: res.data });
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    loopMap = data => {
        return data.map(item => {
            if (item.children && (item.children.length > 0)) {
                return (
                    <TreeNode
                        title={<div className="violate_item">{item.optionValue}</div>}
                        key={item.filterFailOptionId + ''}
                        selectable={false}
                    >
                        { this.loopMap(item.children) }
                    </TreeNode>
                )
            } else {
                return (
                    <TreeNode
                        title={<div className="violate_item">{item.optionValue}</div>}
                        key={item.filterFailOptionId + ''}
                    />
                )
            }
        })
    }

    handeTreeSelect = (selectedKeys, info) => {
        if (selectedKeys && selectedKeys.length) {
            const { node: { props: { title: { props: { children: targetName } } } } } = info;
            this.setState({
                targetName,
                targetId: selectedKeys[0],
            });
        }
    }

    getCutOverList = () => {
        const { list, cutOverName, optionList } = this.state;
        const array = [];
        optionList.forEach(item => {
            if (item) {
                array.push(
                    <a
                        className="item"
                        onClick={() => this.handleItemClick(item)}
                        disabled={list.some(i => i.cutOverName == item)}
                    >
                        <span className={`innerItem${cutOverName == item ? ' select' : ''}`}>
                            <Icon type="file" style={{marginRight:4}} />
                            {item}
                        </span>
                    </a>
                )
            }
        })
        return array;
    }

    handleItemClick = (name) => {
        this.setState({ cutOverName: name });
    }

    replace = () => {
        const { list, targetId, targetName, cutOverName } = this.state;
        list.push({
            targetId,
            targetName,
            cutOverName,
        });
        this.setState({
            list,
            targetId: '',
            targetName: '',
            cutOverName: '',
        });
    }

    delete = (index) => {
        const { list } = this.state;
        list.splice(index, 1);
        this.setState({ list });
    }

    confirm = () => {
        const { list, moduleDefineId } = this.state;

        let isExist = false;
        const params = {};
        list.forEach(item => {
            if (item.targetId) {
                isExist = true;
                params[`params[${item.cutOverName}]`] = item.targetId;
            }
        });
        if (!isExist) {
            message.warning('请选择要割接的选项');
            return;
        }

        this.setState({confirmLoading: true});

        const options = {
            url: API_URL.executeMgr.optionModuleDefineCutOver,
            data: {
                ...params,
                isFail: 1,
                moduleDefineId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ confirmLoading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            },
            failResult: () => {
                this.setState({ confirmLoading: false });
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { list, visible, targetId, cutOverName, confirmLoading } = this.state;
        return (
            visible &&
            <Modal
                title="待割接选项"
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="800px"
                confirmLoading={confirmLoading}
            >
                <div className="cutover">
                    <div className="cutover-content">
                        <div className="modal-left">
                            <ul className="modal-list">
                                <li className="modal-item" style={{paddingBottom: 20}}>
                                    <Tree showLine selectedKeys={[targetId]} onSelect={this.handeTreeSelect}>
                                        { this.getDataList() }
                                    </Tree>
                                </li>
                            </ul>
                        </div>
                        <div className="modal-middle">
                            <Button type="primary" disabled={!(targetId && cutOverName)} onClick={this.replace}>>>替换</Button>
                        </div>
                        <div className="modal-right">
                            <div className="title"><Icon type="switcher" style={{marginRight:4}} />待割接选项</div>
                            { this.getCutOverList() }
                        </div>
                    </div>
                    <div className="cutover-bottom">
                        <div className="bottom-left">割接结果:</div>
                        <div className="bottom-right">
                            {
                                list.map((item, index) => (
                                    item.targetName ?
                                        <div className="item" key={item.cutOverName}>
                                            <div className="text">
                                                {`使用“${item.targetName}”替换“${item.cutOverName}”`}</div>
                                                <Icon className="icon" type="close" onClick={() => this.delete(index)}
                                            />
                                        </div>
                                    :
                                        false
                                ))
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default CutoverModal ;


// WEBPACK FOOTER //
// ./src/components/executeMgr/CutoverModal.js